import { render, staticRenderFns } from "./NInput.vue?vue&type=template&id=273dd9e4&scoped=true&"
import script from "./NInput.vue?vue&type=script&lang=js&"
export * from "./NInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273dd9e4",
  null
  
)

export default component.exports